import { useState } from "react";

const STEPS = [
  "Basic Info",
  "Business Type",
  "Business Category",
  "Operations",
  "Main Challenges",
];

const BUSINESS_TYPES = [
  "Manufacturer",
  "Supplier",
  "Dealer",
  "Distributor",
  "Wholesaler",
  "Retailer",
  "Painting Contractors",
  "Professional Painter",
  "Industrial Applicator",
  "Service Provider",
  "Transport / Logistics",
  "Testing Lab",
  "Other"
];
const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const BUSINESS_CATEGORIES = {
  "PAINT RELATED": [
    "Decorative Paint – Interior",
    "Decorative Paint – Exterior",
    "Industrial Paint",
    "Automotive Paint",
    "Waterproofing Products",
    "Epoxy / PU Coating",
    "Powder Coating",
    "Wood Coating",
    "Primer",
    "Wall Putty",
    "POP/ channel ",
    "Texture",
    "PVC Panels",
    "other_paint_related"
  ],
  "RAW MATERIAL": [
    "Dolomite", "Calcite", "China Clay", "Talc Powder", "Barytes",
    "Titanium Dioxide", "Resin", "Pigments", "Solvents",
    "Additives", "Emulsifier", "Hardener",
    "other_row_material"
  ],
  "PACKAGING MATERIAL": [
    "Plastic Buckets", "HDPE Containers", "Metal Tins",
    "Lids / Handles", "Carton Boxes", "Printed Labels",
    "Stickers", "Shrink Wrap", "Caps & Closures",
    "other_packaging_material"
  ],
  "MACHINERY": [
    "High Speed Disperser", "Ball Mill", "Sand Mill",
    "Ribbon Blender", "Mixing Tank", "Grinding Machine",
    "Filling Machine", "Sealing Machine", "Labeling Machine",
    "Lab Testing Equipment",
    "other_machinery"
  ],
  "TOOLS & EQUIPMENT": [
    "Paint Brush", "Roller", "Spray Gun", "Trowel",
    "Scraper", "Extension Rod", "Paint Tray",
    "Safety Mask", "Gloves", "Surface Preparation Tools",
    "other_tools_equipment"
  ],
  "CONTRACTOR / SERVICES": [
    "Interior Painting", "Exterior Painting",
    "Waterproofing Work", "Industrial Coating Work",
    "Residential Projects", "Commercial Projects",
    "Machinery Installation", "Maintenance Service",
    "Plant Setup Consultancy", "Quality Testing",
    "Technical Consultancy",
    "Artwork",
    "other_contractor_services"
  ],
  "SERVICES": [
    "Interior Designer",
    "Exterior Designer",
    "Waterproofing Service",
    "POP / False Ceiling Work",
    "PVC Panel Service",
    "3D Wallpaper / Wall Panel Service",
    "Wall Texture & Surface Finishing",
    "other_services"
  ],
  "Wholesaler": [
    "Decorative Paint",
    "Industrial Paint",
    "Raw Materials",
    "Packaging Materials",
    "Machinery",
    "Tools & Equipment",
    "Multiple Brand Trading",
    "other_wholesaler"
  ],
  "Retailer": [
    "Decorative Paint Retail",
    "Industrial Products Retail",
    "Hardware Store",
    "Building Materials",
    "Paint Accessories",
    "Waterproofing Products",
    "Multi Brand Outlet",
    "other_retailer"
  ],
  "Transport / Logistics": [
    "Local Transport",
    "State Level Transport",
    "Pan India Logistics",
    "Bulk Chemical Transport",
    "Warehouse Service",
    "Cold Storage",
    "Fleet Owner",
    "other_transport_logistics"
  ],
  "Testing Lab": [
    "Paint Testing",
    "Raw Material Testing",
    "Quality Certification",
    "Lab Equipment Testing",
    "Chemical Analysis",
    "Industrial Compliance Testing",
    "other_testing_lab"
  ],
  "Painting Contractor": [
    "House Painting Contractor",
    "Commercial Painting Contractor",
    "Industrial Painting Contractor",
    "Texture & Designer Work Contractor",
    "Waterproofing Contractor",
    "Surface Finishing Contractor",
    "Turnkey Painting Contractor",
    "other_painting_contractor"
  ],
  "Professional Painter": [
    "Interior Wall Painting",
    "Exterior Wall Painting",
    "Texture Painting",
    "Wood & Metal Painting",
    "Spray Painting",
    "Wall Art / Designer Painting",
    "Surface Finishing (POP, Texture, Putty Work)",
    "Wallpaper / 3D Wallpaper Installation",
    "PVC Panel Installation",
    "Waterproofing Work",
    "other_professional_painter"
  ],
  "Other": [
    "Consultancy",
    "Import / Export",
    "Franchise Partner",
    "Online Seller",
    "Trading Agent",
    "other_other"
  ]
};

const YEARS_OPTIONS = ["0–1 Year", "1–3 Years", "3–5 Years", "5–10 Years", "10+ Years"];
const STATES = ["Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Jammu & Kashmir", "Ladakh", "Other"];

function validate(step, data) {
  const errors = {};
  if (step === 0) {
    if (!data.password) errors.password = "Password is required";
    else if (data.password.length < 8)
      errors.password = "Password must be at least 8 characters";
    if (!data.fullName?.trim()) errors.fullName = "Full name is required";
    else if (data.fullName.trim().length < 2) errors.fullName = "Name must be at least 2 characters";
    if (!data.businessName?.trim()) errors.businessName = "Business name is required";
    if (!data.mobile?.trim()) errors.mobile = "Mobile number is required";
    else if (!/^[6-9]\d{9}$/.test(data.mobile.trim())) errors.mobile = "Enter valid 10-digit Indian mobile number";
    if (!data.whatsapp?.trim()) errors.whatsapp = "WhatsApp number is required";
    else if (!/^[6-9]\d{9}$/.test(data.whatsapp.trim())) errors.whatsapp = "Enter valid 10-digit WhatsApp number";
    if (!data.email?.trim()) errors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email.trim())) errors.email = "Enter a valid email address";
    if (!data.city?.trim()) errors.city = "City is required";
    if (!data.state) errors.state = "Please select a state";
    if (!data.address?.trim()) errors.address = "Address is required";
    if (!data.yearsInBusiness) errors.yearsInBusiness = "Please select years in business";
  }
  if (step === 1) {
    if (!data.businessTypes || data.businessTypes.length === 0)
      errors.businessTypes = "Please select at least one business type";
    // if (!data.entityCategory) errors.entityCategory = "Please select a business entity type";
    // if (!data.entitySubTypes || data.entitySubTypes.length === 0)
    //   errors.entitySubTypes = "Please select at least one sub-type";
  }
  if (step === 2) {
    if (!data.businessCategories || data.businessCategories.length === 0) errors.businessCategories = "Please select at least one business category";
  }
  if (step === 3) {
    if (!data.operationArea) errors.operationArea = "Please select your operation area";
  }
  if (step === 0 && data.gstNumber) {
    if (!gstRegex.test(data.gstNumber)) {
      errors.gstNumber = "Invalid GST Number format";
    }
  }
  if (step === 0) { // Brand Association Step
    if (!data.isAuthorizedPartner)
      errors.isAuthorizedPartner = "Please select an option";

    if (data.isAuthorizedPartner === "Yes") {
      if (!data.companyName?.trim())
        errors.companyName = "Company name is required";

      if (!data.authorizationStatus)
        errors.authorizationStatus = "Select authorization status";
    }

    if (data.isAuthorizedPartner === "No") {
      if (!data.sellerType)
        errors.sellerType = "Please select seller type";
    }
  }
  if (step === 4 && data.challenges.length === 0) {
    errors.challenges = "Please select at least one challenge";
  }
  return errors;
}

export default function PaintIndustryRegistration() {
  const [step, setStep] = useState(0);
  const [showPassword, setShowPassword] = useState(false);

  const [data, setData] = useState({
    businessTypes: [],
    businessCategories: [],
    otherBusinessCategory: {},
    challenges: [],
    gstNumber: "",
    isAuthorizedPartner: "",
    companyName: "",
    authorizationStatus: "",
    sellerType: ""
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [touched, setTouched] = useState({});

  const set = (key, val) => setData(p => ({ ...p, [key]: val }));
  const touch = (key) => setTouched(p => ({ ...p, [key]: true }));

  const goNext = () => {
    const errs = validate(step, data);
    if (Object.keys(errs).length > 0) { setErrors(errs); setTouched(Object.fromEntries(Object.keys(errs).map(k => [k, true]))); return; }
    setErrors({});
    setStep(s => s + 1);
    window.scrollTo(0, 0);
  };
  const goBack = () => { setStep(s => s - 1); setErrors({}); window.scrollTo(0, 0); };
  console.log(data, 'ooo')

  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    try {
      setLoading(true);

      const finalData = {
        ...data,
        entitySubTypes: data.entitySubTypes || [],
        businessCategories: data.businessCategories || [],
        challenges: data.challenges || [],
      };

      const response = await fetch(
        "https://api.webeasytools.com/paint_cart_register.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(finalData),
        }
      );

      const result = await response.json();

      if (result.status === true) {
        setSubmitted(true);
      } else {
        alert(result.message || "Registration failed");
      }

    } catch (error) {
      alert("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const getVisibleCategories = (roles = []) => {
    const visible = [];

    if (roles.includes("Wholesaler") || roles.includes("Supplier") || roles.includes("Manufacturer") || roles.includes("Dealer") || roles.includes("Distributor")) {
      visible.push("PAINT RELATED");
    }

    if (roles.includes("Supplier") || roles.includes("Manufacturer")) {
      visible.push("RAW MATERIAL", "PACKAGING MATERIAL", "MACHINERY");
    }

    if (roles.includes("Industrial Applicator")) {
      visible.push("CONTRACTOR / SERVICES", "TOOLS & EQUIPMENT");
    }

    if (roles.includes("Painting Contractors")) {
      visible.push("Painting Contractor");
    }
    if (roles.includes("Professional Painter")) {
      visible.push("Professional Painter");
    }

    if (roles.includes("Service Provider")) {
      visible.push("SERVICES");
    }

    if (roles.includes("Wholesaler")) {
      visible.push("Wholesaler");
    }

    if (roles.includes("Retailer")) {
      visible.push("Retailer");
    }

    if (roles.includes("Transport / Logistics")) {
      visible.push("Transport / Logistics");
    }

    if (roles.includes("Testing Lab")) {
      visible.push("Testing Lab");
    }

    if (roles.includes("Other")) {
      visible.push("Other");
    }

    return [...new Set(visible)];
  };

  const toggleArr = (key, val) => {
    setData(p => {
      const arr = p[key] || [];
      return { ...p, [key]: arr.includes(val) ? arr.filter(x => x !== val) : [...arr, val] };
    });
  };

  const field = (key, label, type = "text", extra = {}) => (
    <div style={{ marginBottom: 18 }}>
      <label style={labelStyle}>{label} <span style={{ color: "#e53e3e" }}>*</span></label>
      <input
        type={type}
        value={data[key] || ""}
        onChange={e => { set(key, e.target.value); touch(key); }}
        onBlur={() => { touch(key); const errs = validate(step, { ...data, [key]: data[key] }); setErrors(p => ({ ...p, [key]: errs[key] })); }}
        placeholder={extra.placeholder || ""}
        maxLength={extra.maxLength}
        style={{ ...inputStyle, borderColor: touched[key] && errors[key] ? "#e53e3e" : touched[key] && !errors[key] ? "#38a169" : "#d1d5db" }}
      />
      {touched[key] && errors[key] && <p style={errStyle}>{errors[key]}</p>}
      {/* {touched[key] && !errors[key] && data[key] && <p style={{ ...errStyle, color: "#38a169" }}>✓ Looks good</p>} */}
    </div>
  );
  const textAreafield = (key, label, type = "text", extra = {}) => (
    <div style={{ marginBottom: 18 }}>
      <label style={labelStyle}>{label} <span style={{ color: "#e53e3e" }}>*</span></label>
      <textarea
        type={type}
        value={data[key] || ""}
        onChange={e => { set(key, e.target.value); touch(key); }}
        onBlur={() => { touch(key); const errs = validate(step, { ...data, [key]: data[key] }); setErrors(p => ({ ...p, [key]: errs[key] })); }}
        placeholder={extra.placeholder || ""}
        maxLength={extra.maxLength}
        style={{ ...inputStyle, borderColor: touched[key] && errors[key] ? "#e53e3e" : touched[key] && !errors[key] ? "#38a169" : "#d1d5db" }}
      />
      {touched[key] && errors[key] && <p style={errStyle}>{errors[key]}</p>}
      {/* {touched[key] && !errors[key] && data[key] && <p style={{ ...errStyle, color: "#38a169" }}>✓ Looks good</p>} */}
    </div>
  );

  const selectField = (key, label, options) => (
    <div style={{ marginBottom: 18 }}>
      <label style={labelStyle}>{label} <span style={{ color: "#e53e3e" }}>*</span></label>
      <select
        value={data[key] || ""}
        onChange={e => { set(key, e.target.value); touch(key); }}
        onBlur={() => { touch(key); const errs = validate(step, { ...data, [key]: data[key] }); setErrors(p => ({ ...p, [key]: errs[key] })); }}
        style={{ ...inputStyle, borderColor: touched[key] && errors[key] ? "#e53e3e" : touched[key] && !errors[key] && data[key] ? "#38a169" : "#d1d5db" }}
      >
        <option value="">-- Select --</option>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
      {touched[key] && errors[key] && <p style={errStyle}>{errors[key]}</p>}
    </div>
  );

  if (submitted) return (
    <div style={{ minHeight: "100vh", 
      background: "linear-gradient(153deg, #FF9933 0%, #ffffff 50%, #138808 100%)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: "60px 40px", textAlign: "center", maxWidth: 480, boxShadow: "0 25px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ fontSize: 72, marginBottom: 16 }}>🎉</div>
        <h2 style={{ fontSize: 28, fontWeight: 800, color: "#1e40af", marginBottom: 12 }}>Thank You for Registering with PAINTKART !</h2>
        <p style={{ color: "#6b7280", lineHeight: 1.7, }}>
          Thank you <strong>{data.fullName}</strong>You are now a part of India’s Smart Paint Ecosystem – Founding Partner Network.
        </p>
        <p class="text-gray-600 mb-6">
        Our team will review your details and connect with you shortly with the next steps.
        </p>
        <p class="text-gray-600 mb-6">
        The Smart Paint Ecosystem Platform is launching soon.
        </p>
        <p class="text-gray-600 mb-6">
        For any queries or assistance, feel free to WhatsApp us at +91 93062 10780.
        </p>
        <p class="text-gray-600 mb-6">
        We look forward to building the future of the paint industry together.        </p>

        <a
          href="https://wa.me/919306210780?text=Hello%20I%20just%20registered%20on%20PaintKart"
          target="_blank"
          class="inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-xl shadow-lg transition duration-300"
        >
          Start Chat on WhatsApp
        </a>
      </div>
    </div>
  );
  const toggleArray = (field, value) => {
    setData((prev) => {
      const exists = prev[field].includes(value);

      return {
        ...prev,
        [field]: exists
          ? prev[field].filter((v) => v !== value)
          : [...prev[field], value]
      };
    });
  };
  const progress = ((step) / (STEPS.length - 1)) * 100;
  const Challenges = [
    "Dealer Network Problem",
    "Raw Material Cost High",
    "Payment Delay",
    "Distribution Issue",
    "Market Competition",
    "Low Margin",
    "Slow Moving Stock",
    "Credit Risk",
    "Company Support Low",
    "Buyers Not Available",
    "Bulk Orders Needed",
    "Payment Risk",
    "Regular Work Not Available",
    "Direct Company Contact Needed",
    "Better Pricing Needed",
    "Other"
  ]

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(153deg, #FF9933 0%, #ffffff 50%, #138808 100%)",
        padding: "0",
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        paddingBottom: '50px'
      }}
    >
      {/* Top Brand Strip */}
      <div
        style={{
          background: "rgba(0,0,0,0.85)",
          color: "#fff",
          textAlign: "center",
          padding: "10px 15px",
          fontWeight: 700,
          letterSpacing: 1,
          fontSize: 14,
        }}
      >
        <strong>PAINTKART</strong>  – <span style={{ color: "#E2E8F0" }}>Powering India’s First Smart Paint Ecosystem </span>
      </div>

      <div style={{
        textAlign: "center",
        maxWidth: 680,
        margin: "0 auto",
        padding: "30px 16px",
      }}>

        <h1 style={{
          fontSize: "clamp(20px,5vw,32px)",
          fontWeight: 900,
          margin: "8px 0 10px",
          color: "#1e293b",
        }}>
        India’s First Smart Paint Ecosystem Platform – Founding Partner Registration
        </h1>
        <p style={{
          fontSize: 14,
          margin: 0,
          color: "#334155",
        }}
        >This registration form is part of a digital initiative to connect the paint and allied industry.
          We are collecting basic business information to build a structured and collaborative industry network.</p>
      </div>
      <div style={{
        margin: "0 10px",
      }}>

        {/* Card */}
        <div style={{
          maxWidth: 680,
          margin: "0 auto 50px",
          background: "#fff",
          borderRadius: 20,
          boxShadow: "0 25px 60px rgba(0,0,0,0.2)",
          overflow: "hidden",
        }}>
          {/* Progress */}
          <div style={{ background: "#f8fafc", padding: "20px 28px", borderBottom: "1px solid #e5e7eb" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#1e40af" }}>Step {step + 1} of {STEPS.length}</span>
              <span style={{ fontSize: 13, color: "#6b7280" }}>{STEPS[step]}</span>
            </div>
            <div style={{ background: "#e5e7eb", borderRadius: 99, height: 6, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${progress}%`, background: "linear-gradient(90deg,#1e40af,#3b82f6)", borderRadius: 99, transition: "width 0.4s ease" }} />
            </div>
            {/* Step dots */}
            <div style={{ display: "flex", gap: 4, marginTop: 12, justifyContent: "center", flexWrap: "wrap" }}>
              {STEPS.map((s, i) => (
                <div key={i} style={{
                  padding: "3px 10px", borderRadius: 99, fontSize: 11, fontWeight: 600,
                  background: i === step ? "#1e40af" : i < step ? "#dbeafe" : "#f1f5f9",
                  color: i === step ? "#fff" : i < step ? "#1e40af" : "#9ca3af",
                }}>{i < step ? "✓ " : ""}{s}</div>
              ))}
            </div>
          </div>

          {/* Form body */}
          <div style={{ padding: "32px 28px" }}>

            {/* STEP 0: Basic Info */}
            {step === 0 && <>
              <h2 style={sectionTitle}>📋 Basic Information</h2>
              {field("fullName", "Full Name", "text", { placeholder: "Enter your full name" })}
              {field("businessName", "Business Name", "text", { placeholder: "Enter your business / firm name" })}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <div>
                  {field("mobile", "Mobile Number", "tel", { placeholder: "10-digit mobile", maxLength: 10 })}
                </div>
                <div>
                  {field("whatsapp", "WhatsApp Number", "tel", { placeholder: "10-digit WhatsApp", maxLength: 10 })}
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <div>

                  {field("email", "Email ID", "email", { placeholder: "your@email.com" })}
                </div>
                <div style={{ marginBottom: 18, position: "relative" }}>
                  {field("password", "Create Password ", showPassword ? "text" : "password", { placeholder: "Minimum 8 characters" })}
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: 12,
                      top: 38,
                      cursor: "pointer",
                      fontSize: 14,
                      color: "#6b7280"
                    }}
                  >
                    {showPassword ? "🙈" : "👁"}
                  </span>
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                <div>{field("city", "City", "text", { placeholder: "Your city" })}</div>
                <div>{selectField("state", "State", STATES)}</div>
              </div>
              <div style={{ marginBottom: 18 }}>
                {/* <label style={labelStyle}>Complete Address <span style={{ color: "#e53e3e" }}>*</span></label> */}
                <div>{textAreafield("address", "Complete Address", "text", { placeholder: "Shop / Office address...", rows: 3 })}</div>
                {/* <textarea
                value={data.address || ""}
                onChange={e => { set("address", e.target.value); touch("address"); }}
                onBlur={() => { touch("address"); }}
                rows={3}
                placeholder="Shop / Office address..."
                style={{ ...inputStyle, resize: "vertical", borderColor: touched.address && errors.address ? "#e53e3e" : touched.address && data.address ? "#38a169" : "#d1d5db" }}
              />
              {touched.address && errors.address && <p style={errStyle}>{errors.address}</p>} */}
              </div>
              {selectField("yearsInBusiness", "Years in Business", YEARS_OPTIONS)}
            </>}

            {/* STEP 1: Business Type */}
            {step === 1 && <>
              <h2 style={sectionTitle}>🏢 Select Business Type</h2>
              <p style={{ color: "#6b7280", fontSize: 13, marginTop: -8, marginBottom: 20 }}>
                Multiple Selection Allowed
              </p>

              {errors.businessTypes && (
                <div style={{
                  background: "#fef2f2",
                  border: "1px solid #fca5a5",
                  borderRadius: 8,
                  padding: "10px 14px",
                  color: "#b91c1c",
                  fontSize: 13,
                  marginBottom: 16
                }}>
                  ⚠ {errors.businessTypes}
                </div>
              )}

              <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                {BUSINESS_TYPES.map(type => {
                  const checked = (data.businessTypes || []).includes(type);
                  return (
                    <button
                      key={type}
                      type="button"
                      onClick={() => toggleArr("businessTypes", type)}
                      style={{
                        padding: "10px 18px",
                        borderRadius: 10,
                        border: "2px solid",
                        cursor: "pointer",
                        fontSize: 14,
                        fontWeight: 600,
                        background: checked ? "#1e40af" : "#f8fafc",
                        color: checked ? "#fff" : "#374151",
                        borderColor: checked ? "#1e40af" : "#e5e7eb",
                        transition: "all 0.15s"
                      }}
                    >
                      {checked ? "✓ " : ""}{type}
                    </button>
                  );
                })}
              </div>

              {/* Other Field */}
              {data.businessTypes?.includes("Other") && (
                <div style={{ marginTop: 16 }}>
                  <label style={labelStyle}>Specify Other Business Type</label>
                  <input
                    type="text"
                    value={data.otherBusinessType || ""}
                    onChange={(e) => set("otherBusinessType", e.target.value)}
                    placeholder="Enter your business type"
                    style={inputStyle}
                  />
                </div>
              )}

              {data.businessTypes?.length > 0 && (
                <div style={{
                  background: "#eff6ff",
                  borderRadius: 8,
                  padding: "10px 14px",
                  marginTop: 12
                }}>
                  <p style={{ margin: 0, fontSize: 13, color: "#1e40af", fontWeight: 600 }}>
                    ✓ {data.businessTypes.length} type(s) selected
                  </p>
                </div>
              )}
            </>}

            {/* STEP 2: Business Category */}
            {step === 2 && <>
              <h2 style={sectionTitle}>📂 Business Category</h2>
              <p style={{ color: "#6b7280", fontSize: 13, marginBottom: 20 }}>
                Multiple Selection Allowed (Based on Your Business Type)
              </p>

              {errors.businessCategories && (
                <div style={{
                  background: "#fef2f2",
                  border: "1px solid #fca5a5",
                  borderRadius: 8,
                  padding: "10px 14px",
                  color: "#b91c1c",
                  fontSize: 13,
                  marginBottom: 16
                }}>
                  ⚠ {errors.businessCategories}
                </div>
              )}

              {getVisibleCategories(data.businessTypes).map(section => (
                <div key={section} style={{
                  marginBottom: 24,
                  background: "#f8fafc",
                  borderRadius: 12,
                  padding: "16px 18px",
                  border: "1px solid #e5e7eb"
                }}>
                  <p style={{
                    margin: "0 0 12px",
                    fontWeight: 800,
                    fontSize: 15,
                    color: "#1e40af"
                  }}>
                    {section}
                  </p>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {BUSINESS_CATEGORIES[section].map(item => {
                      const checked = (data.businessCategories || []).includes(item);
                      return (
                        <>
                          <button
                            key={item}
                            type="button"
                            onClick={() => toggleArr("businessCategories", item)}
                            style={{
                              padding: "8px 14px",
                              borderRadius: 8,
                              border: "2px solid",
                              cursor: "pointer",
                              fontSize: 13,
                              fontWeight: 600,
                              background: checked ? "#1e40af" : "#fff",
                              color: checked ? "#fff" : "#374151",
                              borderColor: checked ? "#1e40af" : "#e5e7eb"
                            }}
                          >
                            {checked ? "✓ " : ""}{item.includes("other_") ? "Other" : item}
                          </button>
                        </>
                      );
                    })}
                  </div>
                  {BUSINESS_CATEGORIES[section].map(item => {
                    const checked = (data.businessCategories || []).includes(item);
                    return (
                      <>
                        {checked && item.includes("other_") && (
                          <div style={{ marginTop: 12 }}>
                            <input
                              type="text"
                              value={data?.otherBusinessCategory[item] || ""}
                              onChange={(e) =>
                                setData((prev) => ({
                                  ...prev,
                                  otherBusinessCategory: {
                                    ...prev?.otherBusinessCategory,
                                    [item]: e.target.value,
                                  },
                                }))
                              }
                              placeholder="Write Other..."
                              style={inputStyle}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              ))}

              {data.businessCategories?.length > 0 && (
                <div style={{
                  background: "#eff6ff",
                  borderRadius: 8,
                  padding: "10px 14px",
                  marginTop: 12
                }}>
                  <p style={{
                    margin: 0,
                    fontSize: 13,
                    color: "#1e40af",
                    fontWeight: 600
                  }}>
                    ✓ {data.businessCategories.length} category selected
                  </p>
                </div>
              )}
            </>}

            {/* STEP 3: Operations */}
            {step === 3 && <>
              <h2 style={sectionTitle}>🗺 Business Operation Area</h2>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(140px,1fr))", gap: 12, marginTop: 8 }}>
                {["Local", "District Level", "State Level", "Pan India"].map(area => (
                  <button key={area} type="button" onClick={() => { set("operationArea", area); touch("operationArea"); }}
                    style={{
                      padding: "20px 12px", borderRadius: 12, border: "2px solid", cursor: "pointer", textAlign: "center",
                      background: data.operationArea === area ? "#1e40af" : "#f8fafc",
                      color: data.operationArea === area ? "#fff" : "#374151",
                      borderColor: data.operationArea === area ? "#1e40af" : "#e5e7eb",
                      fontWeight: 700, fontSize: 14, transition: "all 0.15s"
                    }}>
                    {area === "Local" ? "📍" : area === "District Level" ? "🏙" : area === "State Level" ? "🗺" : "🇮🇳"}<br />
                    <span style={{ fontSize: 13, display: "block", marginTop: 6 }}>{area}</span>
                  </button>
                ))}
              </div>
              {touched.operationArea && errors.operationArea && <p style={errStyle}>{errors.operationArea}</p>}
            </>}

            {/* STEP 4: GST DETAILS */}
            {step === 0 && <>
              {/* <h2 style={sectionTitle}>🧾 GST Details</h2> */}

              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>
                  GST Number <span style={{ fontSize: 12, color: "#6b7280" }}>(Optional – Phase 1)</span>
                </label>

                <input
                  type="text"
                  value={data.gstNumber}
                  onChange={(e) => set("gstNumber", e.target.value.toUpperCase())}
                  placeholder="Enter GST Number (if available)"
                  style={inputStyle}
                />

                {errors.gstNumber && (
                  <p style={{ color: "#e53e3e", fontSize: 12 }}>
                    {errors.gstNumber}
                  </p>
                )}
              </div>
            </>}

            {/* STEP 5: MAIN CHALLENGES */}
            {step === 4 && <>
              <h2 style={sectionTitle}>⚡ Main Business Challenges</h2>

              <p style={{ fontSize: 14, color: "#6b7280", marginBottom: 15 }}>
                (Multiple Selection Allowed)
              </p>

              <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                {Challenges.map(challenge => {
                  const checked = (data.challenges || []).includes(challenge);
                  return (
                    <button
                      key={challenge}
                      type="button"
                      onClick={() => toggleArray("challenges", challenge)}
                      style={{
                        padding: "10px 18px",
                        borderRadius: 10,
                        border: "2px solid",
                        cursor: "pointer",
                        fontSize: 14,
                        fontWeight: 600,
                        background: checked ? "#1e40af" : "#f8fafc",
                        color: checked ? "#fff" : "#374151",
                        borderColor: checked ? "#1e40af" : "#e5e7eb",
                        transition: "all 0.15s"
                      }}
                    >
                      {checked ? "✓ " : ""}{challenge}
                    </button>
                  );
                })}
              </div>

              {data.challenges.includes("Other") && (
                <div style={{ marginTop: 15 }}>
                  <input
                    type="text"
                    placeholder="Describe your challenge"
                    value={data.otherChallenge || ""}
                    onChange={(e) => set("otherChallenge", e.target.value)}
                    style={inputStyle}
                  />
                </div>
              )}
            </>}

            {/* STEP 6: Brand Association */}
            {step === 0 && <>
              {/* <h2 style={sectionTitle}>🏷 Brand Association</h2> */}

              {/* Authorized Partner */}
              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>
                  Are you an Authorized Brand Partner / Dealer? <span style={{ color: "#e53e3e" }}>*</span>
                </label>

                <div style={{ display: "flex", gap: 12 }}>
                  {["Yes", "No"].map(option => (
                    <button
                      key={option}
                      type="button"
                      onClick={() => {
                        set("isAuthorizedPartner", option);
                        set("companyName", "");
                        set("authorizationStatus", "");
                        set("sellerType", "");
                      }}
                      style={{
                        padding: "10px 18px",
                        borderRadius: 8,
                        border: "2px solid",
                        cursor: "pointer",
                        background: data.isAuthorizedPartner === option ? "#1e40af" : "#f8fafc",
                        color: data.isAuthorizedPartner === option ? "#fff" : "#374151",
                        borderColor: data.isAuthorizedPartner === option ? "#1e40af" : "#e5e7eb",
                        fontWeight: 600
                      }}
                    >
                      {option}
                    </button>
                  ))}
                </div>

                {errors.isAuthorizedPartner && <p style={errStyle}>{errors.isAuthorizedPartner}</p>}
              </div>

              {/* IF YES */}
              {data.isAuthorizedPartner === "Yes" && (
                <>
                  {field("companyName", "Company / Firm Name", 'text', { placeholder: "Enter your registered business name" })}

                  <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                      Do you have Agency / Authorization Letter? <span style={{ color: "#e53e3e" }}>*</span>
                    </label>

                    <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                      {["Yes", "No", "Will Share Later"].map(option => (
                        <button
                          key={option}
                          type="button"
                          onClick={() => set("authorizationStatus", option)}
                          style={{
                            padding: "8px 16px",
                            borderRadius: 8,
                            border: "2px solid",
                            cursor: "pointer",
                            background: data.authorizationStatus === option ? "#1e40af" : "#fff",
                            color: data.authorizationStatus === option ? "#fff" : "#374151",
                            borderColor: data.authorizationStatus === option ? "#1e40af" : "#e5e7eb",
                            fontWeight: 600
                          }}
                        >
                          {option}
                        </button>
                      ))}
                    </div>

                    {errors.authorizationStatus && <p style={errStyle}>{errors.authorizationStatus}</p>}
                  </div>
                </>
              )}

              {/* IF NO */}
              {data.isAuthorizedPartner === "No" && (
                <div style={{ marginBottom: 18 }}>
                  <label style={labelStyle}>
                    Select Business Type <span style={{ color: "#e53e3e" }}>*</span>
                  </label>

                  <div style={{ display: "flex", gap: 12 }}>
                    {["Multi Brand Seller", "Independent Seller"].map(option => (
                      <button
                        key={option}
                        type="button"
                        onClick={() => set("sellerType", option)}
                        style={{
                          padding: "10px 18px",
                          borderRadius: 8,
                          border: "2px solid",
                          cursor: "pointer",
                          background: data.sellerType === option ? "#1e40af" : "#f8fafc",
                          color: data.sellerType === option ? "#fff" : "#374151",
                          borderColor: data.sellerType === option ? "#1e40af" : "#e5e7eb",
                          fontWeight: 600
                        }}
                      >
                        {option}
                      </button>
                    ))}
                  </div>

                  {errors.sellerType && <p style={errStyle}>{errors.sellerType}</p>}
                </div>
              )}
            </>}

            {/* Navigation */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 32, gap: 12 }}>
              {step > 0 ? (
                <button type="button" onClick={goBack} style={secondaryBtn}>← Back</button>
              ) : <div />}
              {step < STEPS.length - 1 ? (
                <button type="button" onClick={goNext} style={primaryBtn}>
                  Continue → <span style={{ fontSize: 12, opacity: 0.8 }}>{STEPS[step + 1]}</span>
                </button>
              ) : (

                <button disabled={loading} type="button" onClick={handleSubmit} style={{ ...primaryBtn, background: "linear-gradient(135deg,#16a34a,#15803d)" }}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

const labelStyle = { display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 };
const inputStyle = {
  width: "100%", boxSizing: "border-box", padding: "10px 14px", borderRadius: 8, border: "2px solid #d1d5db",
  fontSize: 14, color: "#111827", outline: "none", background: "#fff", transition: "border-color 0.15s",
  fontFamily: "inherit"
};
const errStyle = { margin: "5px 0 0", fontSize: 12, color: "#e53e3e", fontWeight: 500 };
const sectionTitle = { fontSize: 20, fontWeight: 800, color: "#1e40af", marginTop: 0, marginBottom: 20 };
const primaryBtn = {
  padding: "12px 28px", borderRadius: 10, border: "none", cursor: "pointer", fontWeight: 700, fontSize: 15,
  background: "linear-gradient(135deg,#1e40af,#3b82f6)", color: "#fff", boxShadow: "0 4px 15px rgba(30,64,175,0.3)",
  transition: "all 0.15s", fontFamily: "inherit"
};
const secondaryBtn = {
  padding: "12px 24px", borderRadius: 10, border: "2px solid #e5e7eb", cursor: "pointer", fontWeight: 600,
  fontSize: 14, background: "#f8fafc", color: "#374151", fontFamily: "inherit"
};